import { IState } from '../../store';

type TPuids = { [key: string]: string };

export function selectAdfoxParams(state: IState): TPuids {
  return state.adfoxParams as TPuids;
}
